<div class="msg">
    <span i18n="@@session_expired">Your session has expired.</span>
</div>
